module.exports = __webpack_public_path__ + "img/expro4.2f4cdbb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/tpl/expro4.png
// module id = mOAq
// module chunks = 57